export const INGRESO_LOGOS = [
  "inDescarga.jpg", "inArribado.jpg", "enProcesoDeDescarga.jpg",
  "descargaFinalizada.jpg", "operativaIngresoFinalizado.jpg",
];
export const EGRESO_LOGOS = [
  "outCarga.jpg", "outArribado.jpg", "enProcesoDeCarga.jpg",
  "cargaFinalizada.jpg", "operativaEgresoFinalizado.jpg",
];

const normalize = (file) => String(file || "").trim().replace(/\.(jpg|jpeg|png|gif|svg|webp)$/i, "").toLowerCase();

// D.A.P changes only the displayed asset, never the saved logo/status filename.
export const getTruckLogoImageFile = (file, dap = false) => {
  if (!dap || !file) return file;
  const original = [...INGRESO_LOGOS, ...EGRESO_LOGOS].find((item) => normalize(item) === normalize(file));
  return original ? `dap/${original.replace(/\.jpg$/, ".png")}` : file;
};
const DAP_HIDDEN_LOGOS = new Set([
  "enprocesodedescarga", "enprocesodecarga",
]);

const allowedFor = (movement, { dap = false } = {}) => {
  const type = String(movement || "").trim().toLowerCase();
  const allowed = type === "ingreso" ? INGRESO_LOGOS : type === "egreso" ? EGRESO_LOGOS : null;
  return allowed && dap ? allowed.filter((file) => !DAP_HIDDEN_LOGOS.has(normalize(file))) : allowed;
};

export const isTruckLogoAllowed = (file, movement, context) => {
  const allowed = allowedFor(movement, context);
  return !file || !allowed || allowed.some((item) => normalize(item) === normalize(file));
};

export const filterTruckLogos = (logos, movement, context) => {
  const files = Array.isArray(logos) ? logos.filter((file) => typeof file === "string" && file.trim()) : [];
  const allowed = allowedFor(movement, context);
  if (!allowed) return files;
  const filtered = files.filter((file) => isTruckLogoAllowed(file, movement, context));
  return filtered.length ? filtered : allowed;
};

const LOGO_LABELS = {
  indescarga: "Ingreso: pendiente de descarga",
  inarribado: "Ingreso: camión arribado",
  enprocesodedescarga: "Ingreso: descarga en proceso",
  descargafinalizada: "Ingreso: descarga finalizada",
  operativaingresofinalizado: "Ingreso: operativa finalizada",
  outcarga: "Egreso: pendiente de carga",
  outarribado: "Egreso: camión arribado",
  enprocesodecarga: "Egreso: carga en proceso",
  cargafinalizada: "Egreso: carga finalizada",
  operativaegresofinalizado: "Egreso: operativa finalizada",
};
export const getTruckLogoLabel = (file) => file ? LOGO_LABELS[normalize(file)] || "Logo actual" : "Sin logo";
